'use client';

import { c as _c } from "react/compiler-runtime";
import { useRef, useState, type PointerEvent } from 'react';
import { attachScrubber } from './scrub';
function seekFromPointer(event: PointerEvent<HTMLInputElement>, controller: ReturnType<typeof attachScrubber> | null) {
  const input = event.currentTarget;
  const bounds = input.getBoundingClientRect();
  const angle = Math.round(Math.max(0, Math.min(1, (event.clientX - bounds.left) / bounds.width)) * 360);
  input.value = String(angle);
  controller?.seek(angle);
}
export function RotationScrubber(t0) {
  const $ = _c(30);
  const {
    src,
    poster,
    name
  } = t0;
  const [degree, setDegree] = useState(0);
  const [ready, setReady] = useState(false);
  const [failed, setFailed] = useState(false);
  const scrubber = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = video => {
      if (!video) {
        return;
      }
      const controller = attachScrubber(video, setDegree);
      scrubber.current = controller;
      if (video.readyState >= HTMLMediaElement.HAVE_METADATA) {
        setReady(true);
      }
      return () => {
        controller.dispose();
        scrubber.current = null;
      };
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = `${name}, full rotation`;
  let t3;
  if ($[1] !== degree) {
    t3 = () => {
      if (degree > 0) {
        scrubber.current?.seek(degree);
      }
      setReady(true);
      setFailed(false);
    };
    $[1] = degree;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setFailed(true);
      setReady(false);
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== poster || $[5] !== src || $[6] !== t2 || $[7] !== t3) {
    t5 = <video key={src} ref={t1} src={src} poster={poster} playsInline={true} muted={true} preload="auto" aria-label={t2} onLoadedMetadata={t3} onError={t4} />;
    $[4] = poster;
    $[5] = src;
    $[6] = t2;
    $[7] = t3;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = String(degree);
  let t7;
  if ($[9] !== t6) {
    t7 = t6.padStart(3, "0");
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span>/ 360°</span>;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t7) {
    t9 = <output className="lookbook-degree">{t7}° {t8}</output>;
    $[12] = t7;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const t10 = `${degree} degrees`;
  const t11 = !ready || failed;
  let t12;
  let t13;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = event_1 => {
      event_1.preventDefault();
      event_1.currentTarget.focus({
        preventScroll: true
      });
      event_1.currentTarget.setPointerCapture(event_1.pointerId);
      scrubber.current?.activate();
      seekFromPointer(event_1, scrubber.current);
    };
    t13 = event_2 => {
      if (event_2.currentTarget.hasPointerCapture(event_2.pointerId)) {
        seekFromPointer(event_2, scrubber.current);
      }
    };
    $[14] = t12;
    $[15] = t13;
  } else {
    t12 = $[14];
    t13 = $[15];
  }
  let t14;
  let t15;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = () => scrubber.current?.activate();
    t15 = event_5 => scrubber.current?.seek(Number(event_5.currentTarget.value));
    $[16] = t14;
    $[17] = t15;
  } else {
    t14 = $[16];
    t15 = $[17];
  }
  let t16;
  if ($[18] !== t10 || $[19] !== t11) {
    t16 = <input type="range" min="0" max="360" step="1" defaultValue="0" aria-label="Rotate look" aria-valuetext={t10} disabled={t11} onPointerDown={t12} onPointerMove={t13} onPointerUp={_temp3} onPointerCancel={_temp4} onKeyDown={t14} onInput={t15} />;
    $[18] = t10;
    $[19] = t11;
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  const t17 = failed ? "Rotation unavailable" : ready ? "Drag to rotate" : "Loading rotation";
  let t18;
  if ($[21] !== t17) {
    t18 = <span className="lookbook-scrub-hint">{t17}</span>;
    $[21] = t17;
    $[22] = t18;
  } else {
    t18 = $[22];
  }
  let t19;
  if ($[23] !== t16 || $[24] !== t18 || $[25] !== t9) {
    t19 = <div className="lookbook-scrub-control" onPointerDown={_temp} onPointerUp={_temp2}>{t9}{t16}{t18}</div>;
    $[23] = t16;
    $[24] = t18;
    $[25] = t9;
    $[26] = t19;
  } else {
    t19 = $[26];
  }
  let t20;
  if ($[27] !== t19 || $[28] !== t5) {
    t20 = <div className="lookbook-rotation">{t5}{t19}</div>;
    $[27] = t19;
    $[28] = t5;
    $[29] = t20;
  } else {
    t20 = $[29];
  }
  return t20;
}
function _temp4(event_4) {
  if (event_4.currentTarget.hasPointerCapture(event_4.pointerId)) {
    event_4.currentTarget.releasePointerCapture(event_4.pointerId);
  }
}
function _temp3(event_3) {
  event_3.currentTarget.releasePointerCapture(event_3.pointerId);
}
function _temp2(event_0) {
  return event_0.stopPropagation();
}
function _temp(event) {
  return event.stopPropagation();
}